import { FEATURED_BOARDS, pairingWallTiles } from './pairingBoards.js';
import { PairingBoardImage } from './PairingBoardImage.js';

/** Right-side wall collage + featured floating boards (Player Pairing v5). */
export function PairingBackdrop() {
  const wall = pairingWallTiles();

  return (
    <div className="pairing-backdrop" aria-hidden>
      <div className="pairing-backdrop__wall">
        {wall.map((name, index) => (
          <div key={`${name}-${index}`} className="pairing-backdrop__tile">
            <PairingBoardImage name={name} />
          </div>
        ))}
      </div>

      {FEATURED_BOARDS.map((card) => (
        <div key={card.name} className={`pairing-backdrop__card ${card.className}`}>
          <PairingBoardImage name={card.name} />
        </div>
      ))}
    </div>
  );
}
